import React from 'react';
import LogoOptions from './LogoOptions';
import MenuOptions from './MenuOptions';
import SocialMediaElementOptions from './SocialMediaElementOptions';
import ButtonElementOptions from './ButtonElementOptions';
import ImageElementOptions from './ImageElementOptions';
import SearchElementOptions from './SearchElementOptions';
import LanguageElementOptions from './LanguageElementOptions';
import ShoppingIconElementOptions from './ShoppingIconElementOptions';
import NavigationElementOptions from './NavigationElementOptions';
import DividerElementOptions from './DividerElementOptions';
import TextBoxElementOptions from './TextBoxElementOptions';

import {
  LOGO,
  MENU,
  SOCIAL_MEDIA,
  BUTTON,
  IMAGE,
  SEARCH,
  LANGUAGE_SELECTOR,
  SHOPPING_ICON,
  NAVIGATION,
  DIVIDER,
  TEXTBOX,
} from '../element-types';

const renderEditor = (props) => {
  const { type } = props;

  switch(type) {
    case LOGO:
      return <LogoOptions {...props} />;
    case MENU:
      return <MenuOptions {...props} />;
    case SOCIAL_MEDIA:
      return <SocialMediaElementOptions {...props} />;
    case BUTTON:
      return <ButtonElementOptions {...props} />;
    case IMAGE:
      return <ImageElementOptions {...props} />;
    case SEARCH:
      return <SearchElementOptions {...props} />;
    case LANGUAGE_SELECTOR:
      return <LanguageElementOptions {...props} />;
    case SHOPPING_ICON:
      return <ShoppingIconElementOptions {...props} />;
    case NAVIGATION:
      return <NavigationElementOptions {...props} />;
    case DIVIDER:
      return <DividerElementOptions {...props} />;
    case TEXTBOX:
      return <TextBoxElementOptions {...props} />;
    default:
      return 'Not Implemented!';
  }
};

const ElementOptions = (props) => (
  <div>
    {renderEditor(props)}
  </div>
);

export default ElementOptions;



// WEBPACK FOOTER //
// ./app/header-builder/components/ElementOptions.js